import { useContext, useState } from "react";
import prettyNumber from "../tables/functions/prettyNumber";
import { useGeneric } from "../useGeneric";
import Loading from "./Loading";
import YoY from "./YoY";
import { isToday } from "../functions";
import AppContext from "../contexts/app-context";
import OrderView from "../tables/instances/newExternals/OrderView";
import flags from "../flags";
import { languagesList } from "../global";
import OrderViewTable from "./OrderViewTable";

export default function SuperStats() {
  const { setModal } = useContext(AppContext);
  const [compareType, setCompareType] = useState(0);
  const [tableType, setTableType] = useState();
  const [lang, setLang] = useState();

  const { rows, loading } = useGeneric({
    name: tableType === "orders" ? "lastOrders" : "dailyStats",
    query: {
      scale: tableType === "orders" ? undefined : tableType,
      lang: lang,
    },
    update: tableType + lang,
    reload: 45,
  });
  const data = !loading && rows;

  return (
    <div>
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            maxWidth: "400px",
          }}
        >
          <button
            className={"nice-button" + (tableType === "year" ? " active" : "")}
            onClick={() => {
              setTableType("year");
              setCompareType(0);
            }}
          >
            Lata
          </button>
          <button
            className={"nice-button" + (!tableType ? " active" : "")}
            onClick={() => setTableType()}
          >
            Miesiące
          </button>
          <button
            className={"nice-button" + (tableType === "day" ? " active" : "")}
            onClick={() => setTableType("day")}
          >
            Dni
          </button>
          <button
            className={
              "nice-button" + (tableType === "orders" ? " active" : "")
            }
            style={{ fontWeight: "bold" }}
            onClick={() => setTableType("orders")}
          >
            Zlecenia
          </button>
        </div>
        {tableType === "day" ? (
          <></>
        ) : tableType === "orders" ? (
          <div className="buttons" style={{ width: "600px" }}>
            <button
              className={"nice-button" + (!lang ? " active" : "")}
              onClick={() => setLang()}
            >
              wszystkie
            </button>
            <button
              className={"nice-button" + (lang === "Ang" ? " active" : "")}
              onClick={() => setLang("Ang")}
            >
              angielski
            </button>
            <button
              className={"nice-button" + (lang === "Niem" ? " active" : "")}
              onClick={() => setLang("Niem")}
            >
              niemiecki
            </button>
            <button
              className={"nice-button" + (lang === "inne" ? " active" : "")}
              onClick={() => setLang("inne")}
            >
              inne
            </button>
          </div>
        ) : (
          <div className="buttons" style={{ width: "600px" }}>
            <button
              className={"nice-button" + (compareType === 0 ? " active" : "")}
              onClick={() => setCompareType(0)}
            >
              Rok do roku
            </button>
            {tableType === "year" ? (
              <></>
            ) : (
              <button
                className={"nice-button" + (compareType === 1 ? " active" : "")}
                onClick={() => setCompareType(1)}
              >
                Miesiąc do miesiąca
              </button>
            )}
          </div>
        )}
      </div>
      {tableType === "orders" ? (
        <OrderViewTable rows={rows} loading={loading} data={data} />
      ) : (
        <table className="reportTable all-stat">
          <thead>
            <tr>
              <th>
                {!tableType ? (
                  <>Miesiąc</>
                ) : tableType === "day" ? (
                  <>Dzień</>
                ) : tableType === "year" ? (
                  <>Rok</>
                ) : (
                  <></>
                )}
              </th>
              <th>Liczba zlec.</th>
              <th>Suma brutto</th>
              <th>Suma brutto ANG</th>
              <th>Suma brutto NIEM</th>
              <th>% sumy ang</th>
              <th>% sumy niem</th>
              <th>Śr. cena zlec.</th>
            </tr>
          </thead>
          {loading ? (
            <Loading />
          ) : rows?.length ? (
            <tbody>
              {data?.map((i, index, arr) => (
                <tr key={i?.day || i?.month || i?.year}>
                  <td>
                    {!tableType ? (
                      <>
                        {i?.year}/{i?.month}
                      </>
                    ) : tableType === "year" ? (
                      <>{i?.year}</>
                    ) : tableType === "day" ? (
                      <>{i.day}</>
                    ) : (
                      <></>
                    )}
                  </td>
                  <td>{i?.["orders"]}</td>
                  <td style={{ width: "190px" }}>
                    <YoY
                      i={i}
                      index={index}
                      arr={arr}
                      p={"sum_gross"}
                      type={compareType}
                      tableType={tableType}
                    />
                    {/* {prettyNumber(i?.["sum_gross"], { round: 0, postfix: " zł" })} */}
                  </td>
                  <td style={{ width: "190px" }}>
                    <YoY
                      i={i}
                      index={index}
                      arr={arr}
                      p={"sum_gross_english"}
                      type={compareType}
                      tableType={tableType}
                    />
                  </td>
                  <td style={{ width: "190px" }}>
                    <YoY
                      i={i}
                      index={index}
                      arr={arr}
                      p={"sum_gross_german"}
                      type={compareType}
                      tableType={tableType}
                    />
                    {/* {prettyNumber(i?.["sum_gross_german"], {
                  round: 0,
                  postfix: " zł",
                })} */}
                  </td>
                  <td>{Math.round(i?.["english_percentage_price"])}%</td>
                  <td>{Math.round(i?.["german_percentage_price"])}%</td>
                  <td>
                    {prettyNumber(i?.["price_per_order_gross"], {
                      round: 0,
                      postfix: " zł",
                    })}
                  </td>
                </tr>
              ))}
            </tbody>
          ) : (
            <>Brak danych</>
          )}
        </table>
      )}
    </div>
  );
}
